<template>
    <transition name="bottomup">
        <b-button v-if="showGoToTop"
            id="page_top"
            type="is-primary"
            class="button mdi mdi-chevron-double-up mdi-36px unPrintTarget"
            @click="goToTop">
        </b-button>
    </transition>
</template>

<script>
export default {
  name: "pageTop",
  methods: {
    calculateScrollY: function() {
        this.scrollY = window.scrollY;
        //何ピクセル移動したらアイコンを表示するか
        if(this.scrollY > 1){
            this.showGoToTop = true;
        } else {
            this.showGoToTop = false;
        }
    }

  },
  data() {
      return {
          scrollY: 0,
          showGoToTop : false
      }
  },
  mounted() {
   window.addEventListener('scroll', this.calculateScrollY);
  },
  beforeDestroy() {
   window.removeEventListener('scroll', this.calculateScrollY);
  },
};
</script>

<style lang="scss">
#page_top{
  width: 30px;
  height: 30px;
  position: fixed;
  right: 10px;
  bottom: 20px;
   /* ▼配色・配置・文字の装飾など */
   border-radius: 10px;  /* ←角丸の半径 */
   text-align: center;  /* ←文字の位置 */
   margin-bottom: 10px;          /* ←外側の余白 */
   padding: 10px;       /* ←内側の余白 */
   opacity: 1.0;        /* 透明度 */
}
.bottomup-enter-active, .bottomup-leave-active {
  transition: all 400ms;    //変化する時間
}
.bottomup-enter, .bottomup-leave-to  {
  opacity: 0;
  transform: translateY(60px); //移動量
}

</style>



// WEBPACK FOOTER //
// src/components/mock/base/pageTop.vue